<template>
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="60"
      height="60"
      rx="30"
      fill="#55ACEE"
    />
    <path
      d="M38.5335 23.6001L26.8001 35.3334L21.4668 30.0001"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
